
import { registerToken } from "@eavfw/quickform-designer/src/Components/Views/QuickFormSettingsView";
import { GroupOnlineTokens } from "./goTokens";
 
registerToken<GroupOnlineTokens>("headlineColor", "Headline Color", "The colour of the quotation headline", "color", undefined, "primary");
registerToken<GroupOnlineTokens>("subtitleColor", "Subtitle Color", "The colour of the quotation subtitle", "color", undefined, "primary");
registerToken<GroupOnlineTokens>("strongWeight", "Bold Weight", "The weight of the strong/bold tag", "text","900");
registerToken<GroupOnlineTokens>("slideButtonBorderRadius", "Button Border Radius", "The border radius of slide button", "text", "100px");

